<template>
  <div>
    <el-card :span="6">
      <el-form ref="searchForm" :model="searchForm">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item label="" prop="studentAccount">
              <el-input style="width: 100%;" v-model="searchForm.studentAccount" placeholder="被分享人电话" @keyup.enter.native="pageList" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item label="" prop="studentReferrerAccount">
              <el-input style="width: 100%;" v-model="searchForm.studentReferrerAccount" placeholder="分享人账号" @keyup.enter.native="pageList" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item label="" prop="tableName">
              <el-input style="width: 100%;" v-model="searchForm.tableName" placeholder="业务名称" @keyup.enter.native="pageList" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item>
              <el-button type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card :span="6" style="margin-top: 20px;">
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;" border v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)" @selection-change="selectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="agentInfo.name" label="机构"></el-table-column>
        <el-table-column prop="source" label="来源">
          <template slot-scope="scope">
            {{ scope.row.source | source }}
          </template>
        </el-table-column>
        <el-table-column prop="tableType" label="业务类型">
          <template slot-scope="scope">
            {{ scope.row.tableType | tableType }}
          </template>
        </el-table-column>
        <el-table-column prop="tableName" label="业务名称"></el-table-column>
        <el-table-column prop="studentReferrer.name" label="分享人"></el-table-column>
        <el-table-column prop="student.name" label="被分享人"></el-table-column>
        <el-table-column prop="studentType" label="学员类型">
          <template slot-scope="scope">
            {{ scope.row.studentType | studentType }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange">
      </el-pagination>
    </el-card>


  </div>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: false,
      blockAddShareReferrerLog: false,
      blockEditShareReferrerLog: false,
      blockDeleteShareReferrerLog: false,
      blockBatchDeleteShareReferrerLog: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: 'create_time',
        sortOrder: 'desc'
      },
      componentSize: '',
      detailFormDialogWidth: '',
      editFormDialogWidth: '',
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        studentReferrerAccount: "",//分享人电话
        studentAccount: "",//被分享人电话
        tableName: ""//商品名称
      },

      editForm: {
        id: null,
        agentId: null,
        source: null,
        sourceId: null,
        tableType: null,
        tableId: null,
        referrerId: null,
        studentId: null,
        studentType: null,
        remark: null,
        state: null,
        operatorId: null,
        updateTime: null,
      },
      searchFormLabelWidth: '0px',
      formLabelWidth: '80px',
      selection: '',
      multipleSelection: '',
      ids: [],
      fileList: [],
      loading: false,
      permissions: []
    }
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize
      this.pageList()
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber
      this.pageList()
    },
    selectionChange (val) {
      this.multipleSelection = val
      this.ids = []
      val.forEach(e => this.ids.push({ id: e.id }))
    },
    getShareReferrerLogDetail () {
      this.api.shareReferrerLog.getShareReferrerLogDetail({
        id: this.selection
      }).then(result => {
        if (result.success) {
          this.detailForm = result.data
        } else {
          this.$message.error(result.message)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getShareReferrerLogById () {
      this.api.shareReferrerLog.getShareReferrerLogById(this.selection).then(result => {
        if (result.success) {
          this.editForm = result.data
        } else {
          this.$message.error(result.message)
        }
      })
    },
    pageList () {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize
      this.searchForm.pageNumber = this.page.pageNumber
      this.searchForm.sortName = this.page.sortName
      this.searchForm.sortOrder = this.page.sortOrder
      this.api.shareReferrerLog.pageList(this.searchForm).then(result => {
        this.page.rows = result.data.records
        this.page.total = result.data.total
        this.tableLoading = false
      }).catch(error => {
        console.log(error)
      })
    },

    reset () {
      this.$refs.searchForm.resetFields()
      this.pageList()
    },
  },
  watch: {
    'detailFormVisible': function (newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: '请稍等',
          target: document.querySelector('.detail-form-dialog')
        })
        this.getShareReferrerLogDetail()
        loading.close()
      }
    },
    'editFormVisible': function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields()
        this.pageList()
      } else {
        let loading = this.$loading.service({
          text: '请稍等',
          target: document.querySelector('.edit-form-dialog')
        })
        this.getShareReferrerLogById()
        loading.close()
      }
    }
  },
  mounted () {
    this.pageList()
  },
  filters: {
    source (item) {
      if (item == 1) {
        return "miniapp";
      }
      if (item == 2) {
        return "pc";
      }
      if (item == 3) {
        return "h5";
      }
      return "";
    },
    tableType (item) {
      if (item == 1) {
        return "商品";
      }
      if (item == 2) {
        return "名片";
      }
      return "";
    },
    studentType (item) {
      if (item == 1) {
        return "新学员";
      }
      if (item == 2) {
        return "老学员";
      }
      return "";
    },
  },

}

</script>



// WEBPACK FOOTER //
// src/components/shareReferrerLog/index.vue